export default "__VITE_ASSET__C6ojhf60__";